'use client';

import { useEffect, useState } from 'react';
import { useDictionary } from '@/context/DictionaryContext';

import styles from './CopyShareLink.module.scss';

interface CopyShareLinkProps {
  shareLink: string;
}

const CopyShareLink = ({ shareLink }: CopyShareLinkProps) => {

  const [copied, setCopied] = useState<boolean>(false);
  const [isMounted, setIsMounted] = useState<boolean>(false);

  const { t } = useDictionary();

  useEffect(() => {
    setIsMounted(true);
  }, []);

  if (!isMounted) {
    return null;
  }

  if (!navigator.clipboard) {
    return null;
  }

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(shareLink);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (error) {
      console.error('Failed to copy the share link:', error);
    }
  };

  return (
    <div className={styles.copyLinkContainer}>
      <button onClick={copyToClipboard} className={`${styles.copyLinkButton} ${copied ? styles.copied : ''}`}>
        <svg
          className="icon"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          {copied ? (
            <path d="M20 6L9 17L4 12" />
          ) : (
            <>
              <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
              <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
            </>
          )}
        </svg>
      </button>

      {copied && (
        <div className={styles.tooltip}>
          {t('share.copied')}
        </div>
      )}
    </div>
  );
};

export default CopyShareLink;